import { Injectable, Inject, InjectionToken } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpRequestClient } from './http-request-client';

const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

// TODO : Work in progress, timeout of requests
@Injectable({
  providedIn: HttpRequestClient,
})
export class MyInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) private defaultTimeout: any) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timeout = Number(req.headers.get('timeout')) || this.defaultTimeout;
    return next.handle(req);
  }
}
